import React from 'react';
import VideocamIcon from '@mui/icons-material/Videocam';
import clsx from 'clsx';

import PostIcon from '@/components/Icons/icons/PostIcon';
import ReelIcon from '@/components/Icons/icons/ReelIcon';
import StoriesIcon from '@/components/Icons/icons/StoriesIcon';
import TikTokFlatIcon from '@/components/Icons/TikTokFlatIcon';

const tagMap = {
  post: { text: 'Post', logo: <PostIcon color="var(--icon-subdued)" width={20} height={20} /> },
  reel: { text: 'Reel', logo: <ReelIcon color="var(--icon-subdued)" width={20} height={20} /> },
  story: { text: 'Story', logo: <StoriesIcon color="var(--icon-subdued)" width={20} height={20} /> },
  video: {
    text: 'Video',
    logo: <VideocamIcon color="var(--icon-subdued)" width={20} height={20} />,
  },
  ttVideo: {
    text: 'Video',
    logo: <TikTokFlatIcon color="currentColor" />,
  },
};
const TypeTag = ({ type, className }) => {
  return <div className={clsx('inline-flex', className)}>{tagMap[type]?.logo}</div>;
};

export default TypeTag;
